// extracted by mini-css-extract-plugin
module.exports = {"record":"CLnt","itemImg":"CLnv","infoWrap":"CLnx","headerLink":"CLkx","authorLink":"CLnz"};